const axios = require("axios");
import * as ENV from '@/config.js'

export const getBookedVenues = async (data) => {
    const res = await axios.post(
        `${ENV.VUE_APP_API_URL}/getcalendar`, data);
    return res.data
}

// const venuesId = [100493406, 100493408, 100493409, 100493410, 100493411, 100493413, 100493416, 100493417, 100493419, 100493420]
export const search = async (data) => {
    const res = await axios.post(`${ENV.VUE_APP_API_URL}/searchbookingsdb/${ENV.VUE_APP_FACILITY}`, {
        ...data,
        // VenueId:venuesId,
        // "OnlyReserved": false,
        // "VenueGroupSearch": false
        "CreatedDate": "",
        "LastUpdatedDate": ""
    });
    return res.data.VenueDetails
}
